import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/AlphalinkDataRecharges';
import { form } from '../Form/alphalinkDataRecharge';
import { form as searchForm } from '../Form/Search/alphalinkDataRecharge';

import { alphalinkDataRecharge as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "alphalinkDataRecharge",
    pageTitle: strings.common.homepage.alphalinkDataRecharge,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_MVNO_CONFIGURATION'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};

      return result;
    },

    availableItemDisplay:['line', 'tab'],
    itemDisplay: {
      line: {
        label: (item) => item["product"].name,
      },
      tab: {
        headers: [
          {
            label: "Produit correspondant",
            value: (item) => item["product"]["name"]
          }
        ]
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.alphalinkDataRecharge,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.alphalinkDataRecharge.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (item, extraValues) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_MVNO_CONFIGURATION'],
        editable: ['ROLE_MVNO_CONFIGURATION']
      }
    }
  },
  new: {
    pageTitle: strings.alphalinkDataRecharge.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (item, extraValues) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
